import styled from "styled-components";

import { Button } from "shared/components/Button/Button";
import { boxShadow, space, zIndex } from "shared/styles/constants";

export const StyledAddEventButton = styled(Button)`
  position: fixed;
  bottom: ${space.l};
  right: ${space.l};

  box-shadow: ${boxShadow.l};
  z-index: ${zIndex.above};
`;
